export enum APPLICATION_STATUS_VALUE_FILTER {
  NEW = "new",
  REJECTED = "rejected",
  REVISION = "returned_for_revision",
  UNDER_REVIEW = "under_review",
  SIGNATURE_REQUIRED = "signature_required",
  OFFER = "offer",
  AWAITING_ISSUE = "awaiting_issue",
  ISSUE = "issue",
  PAYMENT_REQUIRED = "payment_required",
}
